
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gHFZt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5e06a66f42bed623$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $5e06a66f42bed623$export$2e2bcd8739ae039 = {
    'fabric.editor.chromeCollapsedPlaceholder': "Type something\u2026",
    'fabric.editor.editorAssistiveLabel': 'Main content area, start typing to enter text.',
    'fabric.editor.headingLink.toolbarHelpTitle': 'Open help dialog'
};

});


//# sourceMappingURL=en_GB.42bbc9b5.js.map
